function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import classnames from "classnames";
import { mergeProps } from "../../utils/mergeProps";
import { usePropsValue } from "../../utils/use-props-value";
import { bound } from "../../utils/bound";
import CloseIcon from "./icon/closeIcon";
import EyesIcon from "./icon/eyes";
import { isIOS } from "../../utils/validate";
var classPrefix = "tc-input";
var Input = /*#__PURE__*/forwardRef(function (p, ref) {
  var _classnames, _classnames2;
  var props = mergeProps(Input.defaultProps, p);
  var align = props.align,
    autoFocus = props.autoFocus,
    border = props.border,
    clearable = props.clearable,
    disabled = props.disabled,
    formatTrigger = props.formatTrigger,
    formatter = props.formatter,
    id = props.id,
    max = props.max,
    maxLength = props.maxLength,
    min = props.min,
    minLength = props.minLength,
    name = props.name,
    tips = props.tips,
    onBlur = props.onBlur,
    onClear = props.onClear,
    onClick = props.onClick,
    onFocus = props.onFocus,
    isShowPasswordButton = props.isShowPasswordButton,
    onlyShowClearWhenFocus = props.onlyShowClearWhenFocus,
    placeholder = props.placeholder,
    prefixContent = props.prefixContent,
    readOnly = props.readOnly,
    status = props.status,
    suffixContent = props.suffixContent,
    type = props.type,
    onMouseenter = props.onMouseenter,
    onMouseleave = props.onMouseleave,
    onEnterPress = props.onEnterPress,
    onKeydown = props.onKeydown,
    onKeyup = props.onKeyup,
    onCompositionStart = props.onCompositionStart,
    onCompositionEnd = props.onCompositionEnd,
    style = props.style,
    className = props.className,
    pattern = props.pattern;
  /** 劫持value状态，当value不存在时defaultValue生效，且需要onChange外部接管value更新 */
  var _usePropsValue = usePropsValue(props),
    _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
    value = _usePropsValue2[0],
    setValue = _usePropsValue2[1];
  var compositionStartRef = useRef(false);
  var nativeInputRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPassword = _useState2[0],
    toggleShowPassword = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    toggleIsFocused = _useState4[1];
  var _useState5 = useState(type),
    _useState6 = _slicedToArray(_useState5, 2),
    inputType = _useState6[0],
    setInputType = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    working = _useState8[0],
    toggleWorking = _useState8[1];
  useEffect(function () {
    setInputType(type);
  }, [type]);
  useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        setValue("");
      },
      focus: function focus() {
        var _a;
        (_a = nativeInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      },
      blur: function blur() {
        var _a;
        (_a = nativeInputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      },
      get nativeElement() {
        return nativeInputRef.current;
      }
    };
  });
  function handleClear() {
    var _a;
    if (readOnly || disabled) return;
    setValue("");
    onClear === null || onClear === void 0 ? void 0 : onClear("");
    if (isIOS() && compositionStartRef.current) {
      compositionStartRef.current = false;
      (_a = nativeInputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    }
  }
  function handleKeyUp(e) {
    var currentValue = e.currentTarget.value;
    onKeyup === null || onKeyup === void 0 ? void 0 : onKeyup(currentValue, e);
  }
  function handleKeyDown(e) {
    var currentValue = e.currentTarget.value;
    if (onEnterPress && (e.code === "Enter" || e.keyCode === 13)) {
      onEnterPress === null || onEnterPress === void 0 ? void 0 : onEnterPress(currentValue, e);
    }
    onKeydown === null || onKeydown === void 0 ? void 0 : onKeydown(currentValue, e);
  }
  function handleMouseEnter(e) {
    onMouseenter === null || onMouseenter === void 0 ? void 0 : onMouseenter(e);
  }
  function handleMouseLeave(e) {
    onMouseleave === null || onMouseleave === void 0 ? void 0 : onMouseleave(e);
  }
  function handleClick(e) {
    if (readOnly || disabled) return;
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  }
  function handleBlur(e) {
    if (readOnly) return;
    var currentValue = e.currentTarget.value;
    toggleWorking(false);
    checkNumberValue();
    var updateValue = currentValue;
    if (formatter && formatTrigger === "onBlur") {
      updateValue = formatter(updateValue);
      setValue(updateValue);
    }
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(updateValue, e);
    toggleIsFocused(false);
  }
  function handleFocus(e) {
    if (readOnly) return;
    var currentValue = e.currentTarget.value;
    toggleWorking(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(currentValue, e);
    toggleIsFocused(true);
  }
  function handleCompositionStart(e) {
    compositionStartRef.current = true;
    onCompositionStart === null || onCompositionStart === void 0 ? void 0 : onCompositionStart(e);
  }
  function handleCompositionEnd(e) {
    compositionStartRef.current = false;
    onCompositionEnd === null || onCompositionEnd === void 0 ? void 0 : onCompositionEnd(e);
  }
  function handleChange(e) {
    var updateValue = e.target.value;
    // 修复ios中number类型错误输入的问题
    if (type === "number" && isIOS()) {
      updateValue = updateValue.replace(/[^0-9.]+/, "");
    }
    if (formatter && formatTrigger === "onChange") {
      updateValue = formatter(updateValue);
    }
    setValue(updateValue);
  }
  /** 处理max和min失效场景 */
  function checkNumberValue() {
    var nextValue = value;
    if (type === "number") {
      nextValue = nextValue && bound(parseFloat(nextValue), min, max).toString();
    }
    if (nextValue !== value) {
      setValue(nextValue);
    }
  }
  /** 样式相关 */
  var suffixNodeCls = classnames("".concat(classPrefix, "__suffix"));
  var prefixNodeCls = classnames("".concat(classPrefix, "__prefix"));
  var containerCls = classnames("".concat(classPrefix), className, (_classnames = {}, _defineProperty(_classnames, "".concat(classPrefix, "--").concat(status), !!status), _defineProperty(_classnames, "".concat(classPrefix, "--border"), border), _defineProperty(_classnames, "".concat(classPrefix, "--disabled"), disabled || readOnly), _defineProperty(_classnames, "".concat(classPrefix, "--lighting"), border && working), _classnames));
  var clearNodeCls = classnames("".concat(classPrefix, "__clear"));
  var inputNodeCls = classnames("".concat(classPrefix, "__inner"), (_classnames2 = {}, _defineProperty(_classnames2, "".concat(classPrefix, "--text-right"), align === "right"), _defineProperty(_classnames2, "".concat(classPrefix, "--text-center"), align === "center"), _classnames2));
  var passwordBtnCls = classnames("".concat(classPrefix, "__psw-btn"));
  var tipsNodeCls = classnames("".concat(classPrefix, "__tips"));
  /** 输入框节点 */
  var renderInputNode = function renderInputNode() {
    return /*#__PURE__*/React.createElement("input", {
      ref: nativeInputRef,
      type: inputType,
      placeholder: placeholder,
      readOnly: readOnly,
      autoFocus: autoFocus,
      className: inputNodeCls,
      disabled: disabled,
      value: value,
      onChange: handleChange,
      id: id,
      name: name,
      onClick: handleClick,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onCompositionStart: handleCompositionStart,
      onCompositionEnd: handleCompositionEnd,
      max: max,
      maxLength: maxLength,
      min: min,
      minLength: minLength,
      pattern: pattern
    });
  };
  var renderCloseNode = function renderCloseNode() {
    if (!clearable) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    if (!isFocused && onlyShowClearWhenFocus) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    return /*#__PURE__*/React.createElement("div", {
      className: clearNodeCls,
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      },
      onClick: function onClick() {
        handleClear();
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, null));
  };
  var renderSuffixNode = function renderSuffixNode() {
    if (!suffixContent) return /*#__PURE__*/React.createElement(React.Fragment, null);
    return /*#__PURE__*/React.createElement("div", {
      className: suffixNodeCls
    }, suffixContent);
  };
  var renderPrefixNode = function renderPrefixNode() {
    if (!prefixContent) return /*#__PURE__*/React.createElement(React.Fragment, null);
    return /*#__PURE__*/React.createElement("div", {
      className: prefixNodeCls
    }, prefixContent);
  };
  var renderPasswordToggleBtn = function renderPasswordToggleBtn() {
    if (type !== "password") return /*#__PURE__*/React.createElement(React.Fragment, null);
    if (!isShowPasswordButton) return /*#__PURE__*/React.createElement(React.Fragment, null);
    return /*#__PURE__*/React.createElement("div", {
      className: passwordBtnCls,
      onClick: function onClick() {
        if (readOnly || disabled) return;
        setInputType(showPassword ? "password" : "text");
        toggleShowPassword(!showPassword);
      }
    }, /*#__PURE__*/React.createElement(EyesIcon, {
      show: showPassword
    }));
  };
  var renderTips = function renderTips() {
    if (!tips) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: tipsNodeCls
    }, tips);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: containerCls,
    style: style
  }, renderPrefixNode(), renderInputNode(), renderCloseNode(), renderPasswordToggleBtn(), renderSuffixNode(), renderTips());
});
Input.defaultProps = {
  disabled: false,
  readOnly: false,
  autoFocus: false,
  type: "text",
  clearable: false,
  onlyShowClearWhenFocus: false,
  align: "left",
  border: false
};
export default Input;